<div class="case-local-time-container">
  <header class="header-local-time">
     Local Time
  </header>
  <div class="line-local-time"></div>
  <div *ngIf="country">
    <p class="local-time-time">{{ dateVal | TimezoneOffset : timeZoneId}}
      <span *ngIf="countryCodeAlpha2" [ngClass]="'fi fi-' + countryCodeAlpha2.toLowerCase()" (click)="openCountryInfo()"></span>
    </p>
    <div class="local-time-place">
      {{city}} {{country}} ({{ timeZoneId | timeDiff : true }})
    </div>
  </div>
</div>
